var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.671573 0.671573 0 1.5 0H53.5C54.3284 0 55 0.671573 55 1.5C55 2.32843 54.3284 3 53.5 3H1.5C0.671571 3 0 2.32843 0 1.5Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 5.67157 0.671573 5 1.5 5H53.5C54.3284 5 55 5.67157 55 6.5C55 7.32843 54.3284 8 53.5 8H1.5C0.671571 8 0 7.32843 0 6.5Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5C0 10.6716 0.671573 10 1.5 10H53.5C54.3284 10 55 10.6716 55 11.5C55 12.3284 54.3284 13 53.5 13H1.5C0.671571 13 0 12.3284 0 11.5Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 15.6716 0.671573 15 1.5 15H53.5C54.3284 15 55 15.6716 55 16.5C55 17.3284 54.3284 18 53.5 18H1.5C0.671571 18 0 17.3284 0 16.5Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5C0 20.6716 0.671573 20 1.5 20H53.5C54.3284 20 55 20.6716 55 21.5C55 22.3284 54.3284 23 53.5 23H1.5C0.671571 23 0 22.3284 0 21.5Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.5C0 25.6716 0.671573 25 1.5 25H38.5C39.3284 25 40 25.6716 40 26.5C40 27.3284 39.3284 28 38.5 28H1.5C0.671574 28 0 27.3284 0 26.5Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 30.6716 0.671573 30 1.5 30H53.5C54.3284 30 55 30.6716 55 31.5C55 32.3284 54.3284 33 53.5 33H1.5C0.671571 33 0 32.3284 0 31.5Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36.5C0 35.6716 0.671573 35 1.5 35H53.5C54.3284 35 55 35.6716 55 36.5C55 37.3284 54.3284 38 53.5 38H1.5C0.671571 38 0 37.3284 0 36.5Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.5C0 40.6716 0.671573 40 1.5 40H53.5C54.3284 40 55 40.6716 55 41.5C55 42.3284 54.3284 43 53.5 43H1.5C0.671571 43 0 42.3284 0 41.5Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 46.5C0 45.6716 0.671573 45 1.5 45H53.5C54.3284 45 55 45.6716 55 46.5C55 47.3284 54.3284 48 53.5 48H1.5C0.671571 48 0 47.3284 0 46.5Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 51.5C0 50.6716 0.671573 50 1.5 50H24.5C25.3284 50 26 50.6716 26 51.5C26 52.3284 25.3284 53 24.5 53H1.5C0.671572 53 0 52.3284 0 51.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/TEXT.e2625c3aeaa459d0703b04f52b447195.svg";
export { ForwardRef as ReactComponent };